import { OPTION_TYPES } from "../../utils/const"
import { getDateStr } from '../../libs/tools'

export function traverseFromBottom(miList, miFun, self) {
    if (Array.isArray(miList) && typeof miFun === 'function') {
        miList.forEach(mi => {
            traverseFromBottom(mi.childTaskGroupDtos, miFun, self)
            miFun.call(self ? self : this, mi)
        })
    }
}

export function traverseEmi(miList, emiFun, self) {
    if (Array.isArray(miList) && typeof emiFun === 'function') {
        miList.forEach(mi => mi.isEndGroup === 1 ?
            emiFun.call(self ? self : this, mi) :
            traverseEmi(mi.childTaskGroupDtos, emiFun, self))
    }
}

export function isTrueOfMi(mi, isFun, self) {
    if (mi && typeof isFun === 'function') {
        if (mi.isEndGroup === 1) {
            return isFun.call(self ? self : this, mi)
        } else if (Array.isArray(mi.childTaskGroupDtos)) {
            return mi.childTaskGroupDtos.some(c => isTrueOfMi(c, isFun, self))
        }
    }
    return false
}

export function checkSubmit(taskData, tirList) {
    const checkItems = []
    //0不提醒 1提示签字 2强制签字
    let signRemind = taskData.signSource ? 0 : (taskData.storeSign === 1 ? 2 : 1)
    checkItems.push({ result: signRemind, text: `（${signRemind === 2 ? '必' : '选'}填）` })
    //是否有必填项未填
    let unDoRequired = tirList.some(tir => CheckItems[1].boolFun(tir))
    checkItems.push({ result: unDoRequired, text: '' })
    //是否有必提交图片未提交
    let unUploadImage = tirList.some(tir => CheckItems[2].boolFun(tir))
    checkItems.push({ result: unUploadImage, text: '' })
    //是否有必提交视频未提交
    let unUploadVideo = tirList.some(tir => CheckItems[3].boolFun(tir))
    checkItems.push({ result: unUploadVideo, text: '' })
    //0不提醒 1提示整改 2强制整改
    let correctRemind = 0;
    if (taskData.corLimit === 1
        && [1,2].includes(taskData.correctType)
        && tirList.some(tir => CheckItems[4].boolFun(tir))
    ) {
        correctRemind = taskData.correctType
    }
    checkItems.push({ result: correctRemind, text: `（${correctRemind === 2 ? '必' : '选'}填）` })
    //失分项是否任一项必填
    let needLoseAny = false
    //失分项是否文字必填
    let needLoseComment = false
    //失分项是否照片必填
    let needLoseImage = false
    //失分项是否视频必填
    let needLoseVideo = false
    if (typeof taskData.losePointRequired === 'string' && taskData.losePointRequired.length > 2) {
        if (taskData.losePointRequired === '[1]') {
            needLoseAny = tirList.some(tir => CheckItems[5].boolFun(tir))
        } else {
            needLoseComment = taskData.losePointRequired.includes('2') && tirList.some(tir => CheckItems[6].boolFun(tir))
            needLoseImage = taskData.losePointRequired.includes('3') && tirList.some(tir => CheckItems[7].boolFun(tir))
            needLoseVideo = taskData.losePointRequired.includes('4') && tirList.some(tir => CheckItems[8].boolFun(tir))
        }
    }
    checkItems.push({ result: needLoseAny, text: '（必填）' })
    checkItems.push({ result: needLoseComment, text: '（必填）' })
    checkItems.push({ result: needLoseImage, text: '（必填）' })
    checkItems.push({ result: needLoseVideo, text: '（必填）' })

    return {
        checkItems,
        //是否显示提示框
        showRemind: !!(signRemind || unDoRequired || unUploadImage || unUploadVideo || correctRemind
            || needLoseAny || needLoseComment || needLoseImage || needLoseVideo),
        //是否可以提交
        canSubmit: signRemind !== 2 && !unDoRequired && !unUploadImage && !unUploadVideo && correctRemind !== 2
            && !needLoseAny && !needLoseComment && !needLoseImage && !needLoseVideo
    }
}

export function hasImage(tir) {
    return !!(Array.isArray(tir.images) && tir.images.length)
}

export function hasVideo(tir) {
    return !!(Array.isArray(tir.videos) && tir.videos.length)
}

export const CheckItems = [
    {
        text: '完成签字项'
    }, {
        text: '完成必填项',
        boolFun: tir => !!(tir && tir.required && !(
                    tir.phoneIsNa ||
                    (OPTION_TYPES.includes(tir.type) && Array.isArray(tir.options) && tir.options.some(o => o.state)) ||
                    (tir.type === 9 && hasImage(tir)) ||
                    tir.result
                ))
    }, {
        text: '上传必填图片',
        boolFun: tir => !!(tir && typeof tir.phoneOssRequired === 'string'
                            && tir.phoneOssRequired.includes('1') && tir.isShowMedia==1 && !hasImage(tir))
    },  {
        text: '上传必填视频',
        boolFun: tir => !!(tir && typeof tir.phoneOssRequired === 'string'
                            && tir.phoneOssRequired.includes('2') && tir.isShowMedia==1 && !hasVideo(tir))
    }, {
        text: '失分项添加整改',
        boolFun: tir => !!(tir.losePoint && !tir.hasCorrect)
    }, {
        text: '失分项任一项',
        boolFun: tir => !!(tir.losePoint && (tir.isShowRemark || tir.isShowMedia==1) && !tir.comment && !hasImage(tir) && !hasVideo(tir))
    }, {
        text: '失分项添加文字',
        boolFun: tir => !!(tir.losePoint && tir.isShowRemark && !tir.comment)
    }, {
        text: '失分项添加照片',
        boolFun: tir => !!(tir.losePoint && tir.isShowMedia==1 && !hasImage(tir))
    }, {
        text: '失分项添加视频',
        boolFun: tir => !!(tir.losePoint && tir.isShowMedia==1 && !hasVideo(tir))
    }
]

export function getUploadUrl(ttId) {
    const baseUrl = '/wsg/api/upload'
    let paramStr = ''
    if (ttId) {
        paramStr = `?path=${ttId}/task/${getDateStr(new Date(),'year').replaceAll('-','/')}/h5`
    }
    return baseUrl + paramStr
} 